/**
 * tutorLiveScreenPresence — la salle du tuteur (design system) est-elle rendue ?
 *
 * Les écouteurs globaux de la salle (`common/livekit/components-web/LKEvents.tsx`,
 * `common/hooks/livekit/useLiveKitEventListener.js`) restent montés pour toute l'app, et posaient au tuteur leurs
 * bandeaux d'avant (« ✋ … a levé la main », « 🤖 … commence une conversation avec <champion> », « 🤖 Nouveau résumé de
 * point d'avancement », « 🎯 … a terminé une activité ») — un quiz de prérequis y passait pour le champion. Quand
 * cette salle est là, sa colonne dit tout cela à sa façon : les écouteurs le lisent ici et se taisent. Le pendant de
 * `engine/live/student/liveScreenPresence`.
 */
import { createPresenceCount } from "../../../data/utility/presenceCount"

const screens = createPresenceCount()

/** La salle du tuteur se monte : rend la fonction qui la démonte. */
export const markTutorLiveScreen: () => () => void = screens.hold

/** Vrai quand la salle du tuteur est rendue : les bandeaux d'avant se taisent. */
export const isTutorLiveScreenMounted: () => boolean = screens.held
